import {
    UseQueryResult,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { PivotFieldsAggridT } from 'business/definitions';
import { transformUrl } from 'helpers/urlHelpers';
import { snakify } from 'helpers/syntaxHelper';
import { BudgetProposalSettingsT } from 'routes/BudgetModule/config/types';

export const EMPTY_COLUMNS: PivotFieldsAggridT = {
    colDefs: [],
    expandedRows: [],
};

const EMPTY_SETTINGS: BudgetProposalSettingsT = {
    expenseGrid: {
        columns: [],
    },
    analyseExpenseGrid: {
        columns: EMPTY_COLUMNS,
    },
    analyseIncomeGrid: {
        columns: EMPTY_COLUMNS,
    },
    projectsGrid: {
        columns: EMPTY_COLUMNS,
    },
    id: 0,
    resourceType: '',
    resourceSoftwareId: '',
    imputationDimension: '',
    showEmptyBudgetLines: false,
};

export const useSettingsQuery = ({
    options,
    budgetProposalId,
    resourceType,
    softwareId,
    cacheKey,
}: {
    options: Pick<UseQueryOptions<BudgetProposalSettingsT>, 'enabled'>;
    budgetProposalId: number;
    resourceType: string;
    softwareId: string;
    cacheKey: string[];
}): UseQueryResult<BudgetProposalSettingsT> =>
    useQuery({
        queryKey: cacheKey,
        queryFn: async () => {
            const response = await RQAPICallWithData<BudgetProposalSettingsT>({
                endpoint: `budget/proposals/${budgetProposalId}/${resourceType}/${softwareId}/settings`,
                method: 'GET',
                preProcessingUrlCallback: (url) =>
                    transformUrl(url, [3], snakify),
            });
            return response.content.data;
        },
        // The initial state must not change as it is used
        // to fix a race condition in DetailCellRenderer
        initialData: EMPTY_SETTINGS,
        ...options,
    });
